module.exports = __webpack_public_path__ + "img/kasen ibaraki_sc2.c5a23ed4.png";